import classes from './PannelBody.module.css'

const PannelBody = ({children, padding, background}) => {
    return <div className={`${classes.pannel_body} ${padding ? classes[padding] : ''}`} style={{backgroundColor: background}}>
        {children}
    </div>
}

export default PannelBody